// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'
import socketIo from 'socket.io-client'
import App from '../../App'
import routerObj from '../../router/common'
import store from '../../store/A01/index.js'
import axios from 'axios'
import qs from 'qs'
import Vant from 'vant'
import 'vant/lib/index.css'

import '@/assets/images/common/icons/fontawesome/styles.min.css'
import '@/assets/images/common/icons/icomoon/styles.css'
import '@/assets/images/common/icons/material/icons.css'
import '@/styles/common/reset.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "@/directive/dialogdrag";

import {VueJsonp} from 'vue-jsonp';
Vue.use(VueJsonp);

Vue.use(ElementUI)
Vue.use(Vant)

import { Toast } from 'vant';
Vue.use(Toast);

Vue.config.productionTip = false
Vue.prototype.$axios = axios

Vue.use(VueSocketIO, socketIo(process.env.SOCKETIO_PATH, {
  transports: [ "websocket", "polling" ],
  query: {
    auth: Buffer.from(JSON.stringify({
      username: 'socketio',
      password: 'sha256'
    })).toString('base64')
  }
}))

// 由于router.js属于异步导入，所以需要异步处理
routerObj.then(router => {
  // 路由拦截
  router.beforeEach((to, from, next) => {　　// 从cookie中取值并给store中的token赋值
    store.commit('SET_TOKEN', localStorage.getItem('sessionid'))
    if (to.meta.requireAuth) { // 判断是否为true，如果为true就是要登录，去判断token是否存在。存在就执行，不存在就跳转登录页面
      if (store.state.token) {
        next()
      } else {
        window.top.location.href = window.location.protocol + '/'
      }
    } else {
      next()
    }
  })
  //  请求拦截
  let loadingInstance = null
  Vue.prototype.$axios.defaults.timeout = 6000
  Vue.prototype.$axios.interceptors.request.use((config) => {
    if (!config['headers']['loadingFlag']) {
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        loadingInstance = Toast.loading({
          forbidClick: true,
          message: '拼命加载中',
          size: 'large'
        });
      } else {
        loadingInstance = ElementUI.Loading.service({
          lock: true,
          text: '拼命加载中',
          customClass: 'loadingClass',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.01)'
        })
      }
    }
    config['headers']['s-id'] = localStorage.getItem('sessionid')
    config['headers']['Content-Type'] = 'application/x-www-form-urlencoded'
    if (localStorage.getItem('account')) {
      config['headers']['m-id'] = JSON.parse(localStorage.getItem('account')).main_id
      config['headers']['u-id'] = JSON.parse(localStorage.getItem('account')).user_id
    }
    let upType = config['headers']['upType']
    if (upType !== 'file') { // 判断是否为图片上传
      config.data = qs.stringify({ ...config.data })
    }
    return config
  })

  let isSessionId = false
  Vue.prototype.$axios.interceptors.response.use((res) => {
    if (loadingInstance) {
      loadingInstance.close()
    }
    if (res.data.code === '100101' || res.data.code === '100102' || res.data.code === '100103') {
      if (!isSessionId) {
        isSessionId = true
        setTimeout(() => {
          localStorage.removeItem('sessionid')
          isSessionId = false

          if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            if (process.env.NODE_ENV === 'production_zj') {
              location.href = `https://${process.env.WEB_SITE}/`
            } else {
              location.href = `http://${process.env.WEB_SITE}/`
            }
            window.event.returnValue = false
          } else {
            window.top.location.href = window.location.protocol + '/'
          }
        }, 1000)
        return ElementUI.Message.error(res.data.message)
      }
    } else {
      if (+res.data.e === 1) {
        const crypto = require("crypto"); // 解密AES-256-CBC
        const pako = require("pako"); // 解压gzip

        let btoa_data = res.data.data;
    
        // 创建解码器对象
        let base64_data = Buffer.from(btoa_data, "base64");
    
        // 获取AES-256-CBC解密数据
        let iv = base64_data.slice(0, 16); // 密文的前16个字节是IV,16位
        let key = "542b6cd3ZHONGPEIYUNc3cd73174751d"; // 密钥
        let decipher = crypto.createDecipheriv("aes-256-cbc", Buffer.from(key), Buffer.from(iv));
        let decode_data = base64_data.slice(16); // 密文的前16个字节是IV,16位后面才是密文
        let final_string = Buffer.concat([decipher.update(decode_data), decipher.final()]);
    
        return {
          ...res,
          data: {
            ...res.data,
            data: JSON.parse(final_string.toString())
          }
        }
        
        // 解压数据
        // let gzip_data = pako.inflate(final_string, { to: "string" });
    
        // unicode转中文
        // return {
        //   ...res,
        //   data: {
        //     ...res.data,
        //     data: JSON.parse(unescape(gzip_data.toString().replace(/\\u/g, "%u")))
        //   }
        // }
      }
      return res
    }
  }, err => {
    if (Vue.prototype.$axios.isCancel(err)) {
      return console.log(err.message)
    }
    loadingInstance.close()
    return false
  })


  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: {
      App
    },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main/A01/main.js